import { render, staticRenderFns } from "./EarlierConsultation.vue?vue&type=template&id=1ac0c4b2&scoped=true&"
import script from "./EarlierConsultation.vue?vue&type=script&lang=js&"
export * from "./EarlierConsultation.vue?vue&type=script&lang=js&"
import style0 from "./EarlierConsultation.vue?vue&type=style&index=0&id=1ac0c4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0c4b2",
  null
  
)

export default component.exports